import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useGaugebarCouponNotApplicableTextService = () => {
  const params = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(params);

  return {
    gaugebarCouponNotApplicableText: product?.gaugebar_coupon_not_applicable_text,
  };
};
